<template>
    <div id="componente-listado-entes-fiscalizadores">
      <v-container
      fluid >
      <v-card flat>
        <v-card-title>
          <span></span>
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <MainListadoEntesFiscalizadores
        />
      </v-card>
      </v-container>
    </div>
</template>
<script>
import MainListadoEntesFiscalizadores from '@/views/administracion/configuracion/catalogos/entesfiscalizadores/Default.vue';

export default {
  name: 'ComponenteListadoEntesFiscalizadores',
  components: {
    MainListadoEntesFiscalizadores,
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>
